import Vue from 'vue'
import age_category from './age-category/index.vue'
Vue.component('dictionary-age-category', age_category);
import cash from './cash/index.vue'
Vue.component('dictionary-cash', cash);
import certificates_type from './certificates-type/index.vue'
Vue.component('dictionary-certificates-type', certificates_type);
import citizenship from './citizenship/index.vue'
Vue.component('dictionary-citizenship', citizenship);
import currency from './currency/index.vue'
Vue.component('dictionary-currency', currency);
import date_step from './date-step/index.vue'
Vue.component('dictionary-date-step', date_step);
import dates_and_type from './dates-and-type/index.vue'
Vue.component('dictionary-dates-and-type', dates_and_type);
import gender from './gender/index.vue'
Vue.component('dictionary-gender', gender);
import owner_legal from './owner-legal/index.vue'
Vue.component('dictionary-owner-legal', owner_legal);
import payment_account from './payment-account/index.vue'
Vue.component('dictionary-payment-account', payment_account);
import payment_category from './payment-category/index.vue'
Vue.component('dictionary-payment-category', payment_category);
import payment_direction from './payment-direction/index.vue'
Vue.component('dictionary-payment-direction', payment_direction);
import payment_operation from './payment-operation/index.vue'
Vue.component('dictionary-payment-operation', payment_operation);
import payment_type from './payment-type/index.vue'
Vue.component('dictionary-payment-type', payment_type);
import payment_method from './payment-method/index.vue'
Vue.component('dictionary-payment-method', payment_method);
import price from './price/index.vue'
Vue.component('dictionary-price', price);
import type_date from './type-date/index.vue'
Vue.component('dictionary-type-date', type_date);
import web_report from './web-report/index.vue'
Vue.component('dictionary-web-report', web_report);
import online_cashes from './online-cashes/index.vue'
Vue.component('online-cashes-popup', online_cashes);

import './index.scss'


import manager from './manager/index.vue'
Vue.component('dictionary-manager', manager);
